import {} from '../utils/env.js';
import {} from 'viem';
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Unbroadcast"] = "unbroadcast";
    OrderStatus["Pending"] = "pending";
    OrderStatus["Success"] = "success";
    OrderStatus["Failed"] = "failed";
    OrderStatus["Timeout"] = "timeout";
})(OrderStatus || (OrderStatus = {}));
export var CrossSwapOrderStatus;
(function (CrossSwapOrderStatus) {
    CrossSwapOrderStatus["Unbroadcast"] = "unbroadcast";
    CrossSwapOrderStatus["UnknownFailed"] = "unknownFailed";
    CrossSwapOrderStatus["OriginPending"] = "originPending";
    CrossSwapOrderStatus["OriginSuccess"] = "originSuccess";
    CrossSwapOrderStatus["OriginFailed"] = "originFailed";
    CrossSwapOrderStatus["OriginTimeout"] = "originTimeout";
    CrossSwapOrderStatus["DestinationPending"] = "destinationPending";
    CrossSwapOrderStatus["DestinationSuccess"] = "destinationSuccess";
    CrossSwapOrderStatus["DestinationFailed"] = "destinationFailed";
    CrossSwapOrderStatus["DestinationTimeout"] = "destinationTimeout";
})(CrossSwapOrderStatus || (CrossSwapOrderStatus = {}));
//# sourceMappingURL=type.js.map